import { __rest, __assign } from 'tslib';
import React from 'react';
import { Typography as Typography$1 } from '@material-ui/core';
import { defaultTypographyProps } from './TypographyProps.js';
import { useTypographyStyles } from './TypographyStyles.js';

var Typography = function (props) {
    props.weight; props.color; var TypographyRef = props.TypographyRef, restProps = __rest(props, ["weight", "color", "TypographyRef"]);
    var classes = useTypographyStyles(__assign({}, props));
    var variantMapping = { subtitle1: 'p' };
    return React.createElement(Typography$1, __assign({ classes: classes, variantMapping: variantMapping, ref: TypographyRef }, restProps));
};
Typography.displayName = 'Typography';
Typography.defaultProps = defaultTypographyProps;

export { Typography };
//# sourceMappingURL=Typography.js.map
